// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest } from "rxjs";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    projectsOptions: This.Project[];
    employeesOptions: string[];
    chargeabilitiesOptions: { id: boolean, label: string }[];
    filterProjectId: string | null;
    filterDate: Date | null;
    filterStatus: any | null;
    filterEmployee: string | null;
    filterChargeability: boolean | null;
    expenses: This.Expense[];
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Llama-AllExpenses',
    templateUrl: './AllExpenses.html',
    styleUrls: ['./AllExpenses.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AllExpenses extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Llama.AllExpenses';
    $isDialog = false;
    $Modules = $Modules;
    Llama = Llama;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    _DataTableBlock_columns_34 = (screen: Properties) => ['expenseDate', 'name', 'status', 'project', 'employee', 'category', 'currency', 'vatAmount', 'tipAmount', 'totalAmount'];
    $validators: Record<number, ValidationRules> = {

    };
    var_projectsOptions = proxySignal<This.Project[]>(undefined as any);
    var_employeesOptions = proxySignal<string[]>(undefined as any);
    var_chargeabilitiesOptions = proxySignal<{ id: boolean, label: string }[]>(undefined as any);
    var_filterProjectId = proxySignal<string | null>(undefined as any);
    var_filterDate = proxySignal<Date | null>(undefined as any);
    var_filterStatus = proxySignal<any | null>(undefined as any);
    var_filterEmployee = proxySignal<string | null>(undefined as any);
    var_filterChargeability = proxySignal<boolean | null>(undefined as any);
    var_expenses = proxySignal<This.Expense[]>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get projectsOptions() { return component.var_projectsOptions() },
                set projectsOptions(value: This.Project[]) { component.var_projectsOptions.set(value) },
                get employeesOptions() { return component.var_employeesOptions() },
                set employeesOptions(value: string[]) { component.var_employeesOptions.set(value) },
                get chargeabilitiesOptions() { return component.var_chargeabilitiesOptions() },
                set chargeabilitiesOptions(value: { id: boolean, label: string }[]) { component.var_chargeabilitiesOptions.set(value) },
                get filterProjectId() { return component.var_filterProjectId() },
                set filterProjectId(value: string | null) { component.var_filterProjectId.set(value) },
                get filterDate() { return component.var_filterDate() },
                set filterDate(value: Date | null) { component.var_filterDate.set(value) },
                get filterStatus() { return component.var_filterStatus() },
                set filterStatus(value: any | null) { component.var_filterStatus.set(value) },
                get filterEmployee() { return component.var_filterEmployee() },
                set filterEmployee(value: string | null) { component.var_filterEmployee.set(value) },
                get filterChargeability() { return component.var_filterChargeability() },
                set filterChargeability(value: boolean | null) { component.var_filterChargeability.set(value) },
                get expenses() { return component.var_expenses() },
                set expenses(value: This.Expense[]) { component.var_expenses.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this
            if (!isVariablesInitialized) this.screen.projectsOptions = ([])
            if (!isVariablesInitialized) this.screen.employeesOptions = ([])
            if (!isVariablesInitialized) this.screen.chargeabilitiesOptions = ([])
            if (!isVariablesInitialized) this.screen.filterProjectId = (null)
            if (!isVariablesInitialized) this.screen.filterDate = (null)
            if (!isVariablesInitialized) this.screen.filterStatus = (null)
            if (!isVariablesInitialized) this.screen.filterEmployee = (null)
            if (!isVariablesInitialized) this.screen.filterChargeability = (null)
            if (!isVariablesInitialized) this.screen.expenses = ([])
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })

    }

    async handler_DatePickerBlock_27_dateChange_loadExpenses_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_loadExpenses($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_DropdownBlock_28_selectionChange_loadExpenses_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {
            let selection: any = $event
            const { app, screen, output } = this
            try {
                await this.action_loadExpenses($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_DropdownBlock_44_selectionChange_loadExpenses_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {
            let selection: any = $event
            const { app, screen, output } = this
            try {
                await this.action_loadExpenses($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_DropdownBlock_45_selectionChange_loadExpenses_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {
            let selection: any = $event
            const { app, screen, output } = this
            try {
                await this.action_loadExpenses($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_DropdownBlock_46_selectionChange_loadExpenses_0($event: any, $scope: any): Promise<void> {
        let { }: {} = $scope ?? {}

        {
            let selection: any = $event
            const { app, screen, output } = this
            try {
                await this.action_loadExpenses($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    _DataTableBlock_collectionCodeSignal_34(component, $scope: any): any {

        return this.getMemoizedSignal(component, 'collectionCode', () =>
            computed(() => {
                let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}
                return (screen.expenses)
            }, { equal: () => false })
        )

    }

    _DataTableBlock_additionalFindOptions_34($scope: any): any {
        let { app, screen, $pathSegments, $disabled }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean } = $scope ?? {}

        return ({
            where: {
                projectId: screen.filterProjectId || undefined,
                // expenseDate: screen.filter.date,
                isChargeable: true,
                chargedInInvoiceId: null
            }
        })
    }

    _DataTableColumnBlock_cellText_35($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (Sys.Date.format(item.expenseDate, 'dd-MM-yyyy'))
    }

    _DataTableColumnBlock_cellText_36($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.name)
    }

    _DataTableColumnBlock_cellText_43($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.status.label)
    }

    _DataTableColumnBlock_cellText_42($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.project?.name || 'N/A')
    }

    _DataTableColumnBlock_cellText_47($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.employeeEmail)
    }

    _DataTableColumnBlock_cellText_37($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.category$id)
    }

    _DataTableColumnBlock_cellText_38($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.currency$id)
    }

    _DataTableColumnBlock_cellText_39($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.vatAmount)
    }

    _DataTableColumnBlock_cellText_40($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.tipAmount)
    }

    _DataTableColumnBlock_cellText_41($scope: any): any {
        let { app, screen, $pathSegments, $disabled, item, index }: { app: any, screen: any, $pathSegments: string[], $disabled: boolean, item: This.Expense, index: number } = $scope ?? {}

        return (item.totalAmount)
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            screen.projectsOptions = await This.ExpensesDataStore.loadByCondition(This.Project, {})
            screen.employeesOptions = (await This.ExpensesDataStore.count(This.Expense, ['employeeEmail'], {})).map((e) => e.employeeEmail);
            screen.chargeabilitiesOptions = [
                { id: true, label: 'Yes' },
                { id: false, label: 'No' },
            ]


            await this.action_loadExpenses($event)
        }
    }

    async action_loadExpenses($event?: any) {
        const { app, screen, output } = this
        {

            screen.expenses = await This.ExpensesDataStore.loadByCondition(This.Expense, {
                where: {
                    projectId: screen.filterProjectId || undefined,
                    expenseDate: screen.filterDate ? This.ExpensesDataStore.LessThanOrEqual(screen.filterDate) : undefined,
                    status$id: screen.filterStatus || undefined,
                    employeeEmail: screen.filterEmployee || undefined,
                    isChargeable: screen.filterChargeability !== null ? screen.filterChargeability : undefined
                },
                relations: {
                    project: true
                }
            })
        }
    }
}
